module.exports = __webpack_public_path__ + "static/media/038.e23e1fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/038.jpg
// module id = 334
// module chunks = 0